import template from './rw-datepicker.html';

const mapStateToThis = ({ session }) => {
  const { locale } = session;
  return {
    locale,
  };
};

// eslint-disable-next-line no-undef
@Inject('$locale', '$ngRedux')
class RwTimepickerController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  $onInit() {
    this.isOpen = false;
    this.format = this.locale === 'en_US' ? 'MM/dd/yyyy' : this.$locale.DATETIME_FORMATS.mediumDate;
  }

  toggleDatepicker() {
    this.isOpen = !this.isOpen;
  }
}

export default class RwDatepickerComponent {
  constructor() {
    this.template = template;
    this.controller = RwTimepickerController;
    this.require = 'ngModel';
    this.bindings = {
      ngModel: '=',
      name: '@?',
      required: '<?',
      format: '<?',
      onChange: '&?',
    };
  }
}


// WEBPACK FOOTER //
// ./src/modules/utils/rw-datepicker/rw-datepicker-component.js